import { useEffect } from "react"

export function useOnClickOutside(ref: React.RefObject<any>, handler: (event: React.MouseEvent) => void) {
  useEffect(() => {
    const listener = (event: React.MouseEvent) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return
      }

      handler(event)
    }

    document.addEventListener(`mousedown`, listener as any)

    return () => {
      document.removeEventListener(`mousedown`, listener as any)
    }
  }, [ref, handler])
}
